import { StandardFilterType } from '../StandardFilterType';

const CUSTOM_SCORE_MAP: Record<number, StandardFilterType> = {
    1: StandardFilterType.custom1,
    2: StandardFilterType.custom2,
    3: StandardFilterType.custom3,
};

export const getStandardTypeFilterValue = (customScoreNumber: number): StandardFilterType => {
    return CUSTOM_SCORE_MAP[customScoreNumber] ?? StandardFilterType.LQA;
};
